export const ERROR_CURRENCY =
  'Invalid currency format. Enter a positive number with up to two decimal places.';
export const ERROR_GREATER_THAN_ZERO = 'Enter a value of 0 or greater';
export const ERROR_REQUIRED = 'Enter a value to continue';
export const ERROR_NUMBER = 'Enter a number';
export const ERROR_INTEGER = 'Enter a whole number (no decimals)';
export const ERROR_EMAIL = 'Enter a valid email address';
export const ERROR_PHONE_FORMAT = 'Enter a 10-digit phone number';
export const ERROR_ZIP_CODE = 'Enter a 5-digit ZIP code';

export const ERROR_MIN_VALUE = (value: number) =>
  `The minimum value is ${value}`;
export const ERROR_MAX_VALUE = (value: number) =>
  `The maximum value is ${value}`;

export const FormValidations = {
  ERROR_CURRENCY,
  ERROR_EMAIL,
  ERROR_GREATER_THAN_ZERO,
  ERROR_INTEGER,
  ERROR_NUMBER,
  ERROR_PHONE_FORMAT,
  ERROR_REQUIRED,
  ERROR_ZIP_CODE,
};
